import { DocumentFormModel, getPartIdsAndDockingTypeCodesFromSelectedParts } from '../documentFormModel';

export type CreateDocumentDto = {
  documentReference: string;
  documentName: string;
  customerName: string;
  documentUrl: string;
  documentVersion: number | null;
  handoverPackSectionId: number;
  handoverPackSectionSequence: string;
  partIds: Array<number>;
  dockingTypeCodes: Array<string>;
  secondaryPartIds: Array<number>;
  secondaryDockingTypeCodes: Array<string>;
  isAlwaysIncluded: boolean;
  useNuHeatSuppliedHeatPump: boolean;
  useSolar: boolean;
  useUnderfloorHeating: boolean;
  useUserSuppliedHeatPump: boolean;
  useBoiler: boolean;
  useAnyTechnology: boolean;
  matchAllParts: boolean;
  includeInContentsPage: boolean;
  includeInPrintFolder: boolean;
  prePrinted: boolean;
  neverPrint: boolean;
};

export const mapDocumentFormModelToCreateCommand = (model: DocumentFormModel): CreateDocumentDto => {
  const { partIds, dockingTypeCodes } = getPartIdsAndDockingTypeCodesFromSelectedParts(model.parts);
  const {
    partIds: secondaryPartIds,
    dockingTypeCodes: secondaryDockingTypeCodes,
  } = getPartIdsAndDockingTypeCodesFromSelectedParts(model.secondaryParts);
  const useParts =
    model.useNuHeatSuppliedHeatPump ||
    model.useSolar ||
    model.useUnderfloorHeating ||
    model.useUserSuppliedHeatPump ||
    model.useBoiler ||
    model.useAnyTechnology;

  return {
    documentReference: model.documentReference,
    documentName: model.documentName,
    customerName: model.customerName,
    documentUrl: model.documentUrl,
    documentVersion: model.documentVersion.trim() === '' ? null : parseInt(model.documentVersion, 10),
    handoverPackSectionId: model.handoverPackSectionId,
    handoverPackSectionSequence: model.handoverPackSectionSequence,
    partIds: useParts ? partIds : [],
    dockingTypeCodes: useParts ? dockingTypeCodes : [],
    secondaryPartIds: useParts ? secondaryPartIds : [],
    secondaryDockingTypeCodes: useParts ? secondaryDockingTypeCodes : [],
    isAlwaysIncluded: model.isAlwaysIncluded,
    useNuHeatSuppliedHeatPump: !model.isAlwaysIncluded && model.useNuHeatSuppliedHeatPump,
    useSolar: !model.isAlwaysIncluded && model.useSolar,
    useUnderfloorHeating: !model.isAlwaysIncluded && model.useUnderfloorHeating,
    useUserSuppliedHeatPump: !model.isAlwaysIncluded && model.useUserSuppliedHeatPump,
    useBoiler: !model.isAlwaysIncluded && model.useBoiler,
    useAnyTechnology: !model.isAlwaysIncluded && model.useAnyTechnology,
    matchAllParts: !model.isAlwaysIncluded && model.matchAllParts,
    includeInContentsPage: model.includeInContentsPage,
    includeInPrintFolder: model.includeInPrintFolder,
    prePrinted: model.prePrinted,
    neverPrint: model.neverPrint,
  };
};
